import { useState } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import { Imagens } from "../Imagens";  // Reutilizar componente existente
import { Documents } from "../Documents";  // Reutilizar componente existente

import styles from "./styles.module.css";

export function Arquivos({
  imagensPaciente,
  documentsPaciente,
  PatientNameAndId,
  dataAtendimento,
  imagemPerfil,
  loadingImagens,
  isShare,
  idClient,
  seqAtend,
  namePacient
}: any) {
  // Estados para controlar expansão das seções (iniciam expandidas)
  const [documentosExpanded, setDocumentosExpanded] = useState(true);
  const [imagensExpanded, setImagensExpanded] = useState(true);

  // Filtrar apenas imagens (excluindo documentos)
  const imagensFiltradas = imagensPaciente?.filter((img: any) =>
    !img.link.endsWith('.pdf') &&
    !img.complemento?.endsWith('.rar') &&
    !img.complemento?.endsWith('.cfx') 
  ) || [];

  // Filtrar apenas documentos
  const documentosFiltrados = imagensPaciente?.filter((img: any) =>
    img.link.endsWith('.pdf') ||
    img.complemento?.endsWith('.rar') ||
    img.complemento?.endsWith('.zip') ||
    img.complemento?.endsWith('.cfx')
  ) || [];

  // Adicionar documento "Visualizador eVol-DX" apenas para idClient 15831
  const documentosComEvolDx = [...documentosFiltrados];
  
  if (Number(idClient) === 15831 || String(idClient) === "15831") {
    const documentoEvolDx = {
      nome: "Baixar Visualizador DICOM",
      complemento: ".pdf",
      link: "https://cdt.com.br/cli/p/artigos.aspx?q=Downloads",
      linkDownload: "https://cdt.com.br/cli/p/artigos.aspx?q=Downloads",
      icone: "https://cyberbullying.org/wp-content/uploads/2019/02/pdf-download-300x300.png",
      isEvolDx: true // Flag para identificar este documento especial
    };
    
    // Adicionar como segundo item da lista (posição 1)
    documentosComEvolDx.splice(1, 0, documentoEvolDx);
  }

  return (
    <div className={styles.container}>
      {/* Seção Documentos (com card de instruções integrado) */}
      {documentosComEvolDx.length > 0 && (
        <div className={`${styles.section} ${styles.documentsSection}`}>
          <div
            className={styles.sectionHeader}
            onClick={() => setDocumentosExpanded(!documentosExpanded)}
            style={{ cursor: 'pointer' }}
          >
            <h3 className={styles.sectionTitle}>
              📄 Documentos ({documentosComEvolDx.length})
              <button className={styles.expandButton}>
                {documentosExpanded ? <ChevronUpIcon width={20} /> : <ChevronDownIcon width={20} />}
              </button>
            </h3>
            <div className={styles.sectionDivider}></div>
          </div>
          {documentosExpanded && (
          <div className={styles.sectionContent}>
            <Documents
              PatientNameAndId={PatientNameAndId}
              documentsPaciente={documentosComEvolDx}
              imagemPerfil={imagemPerfil}
            />
          </div>
          )}
        </div>
      )}

      {/* Seção Imagens (agora segundo) */}
      {imagensFiltradas.length > 0 && (
        <div className={`${styles.section} ${documentosComEvolDx.length === 0 ? styles.firstSection : ''}`}>
          <div
            className={styles.sectionHeader}
            onClick={() => setImagensExpanded(!imagensExpanded)}
            style={{ cursor: 'pointer' }}
          >
            <h3 className={styles.sectionTitle}>
              📸 Imagens ({imagensFiltradas.length})
              <button className={styles.expandButton}>
                {imagensExpanded ? <ChevronUpIcon width={20} /> : <ChevronDownIcon width={20} />}
              </button>
            </h3>
            <div className={styles.sectionDivider}></div>
          </div>
          {imagensExpanded && (
            <div className={styles.sectionContent}>
              <Imagens
                PatientNameAndId={PatientNameAndId}
                imagensPaciente={imagensFiltradas}
                dataAtendimento={dataAtendimento}
                imagemPerfil={imagemPerfil}
                loadingImagens={loadingImagens}
                isShare={isShare}
                idClient={idClient}
                seqAtend={seqAtend}
                namePacient={namePacient}
              />
            </div>
          )}
        </div>
      )}

      {/* Mensagem quando não há arquivos */}
      {imagensFiltradas.length === 0 && documentosComEvolDx.length === 0 && (
        <div className={styles.emptyState}>
          <div className={styles.emptyIcon}>📂</div>
          <h3>Nenhum arquivo encontrado</h3>
          <p>Não há imagens ou documentos disponíveis para este paciente.</p>
        </div>
      )}
    </div>
  );
}
